const startOfDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

/**
 * Date + time for a conversation entry: "Today, 14:32", "Yesterday, 09:05",
 * "19 Oct, 14:32", or "19 Oct 2025, 14:32" for an older year.
 */
export const formatMessageTimestamp = (value: string | Date, now: Date = new Date()): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const dayDiff = Math.round((startOfDay(now) - startOfDay(date)) / 86_400_000);
  if (dayDiff === 0) return `Today, ${time}`;
  if (dayDiff === 1) return `Yesterday, ${time}`;
  const day = date.toLocaleDateString([], {
    day: 'numeric',
    month: 'short',
    ...(date.getFullYear() !== now.getFullYear() ? { year: 'numeric' } : {}),
  });
  return `${day}, ${time}`;
};

/** "Cleared by Ahmed, Today, 14:32" for a contact's last cleared alert. */
export const clearedByLabel = (cleared: {
  acknowledged_by_name: string | null;
  acknowledged_at: string;
}): string =>
  `Cleared by ${cleared.acknowledged_by_name ?? 'unknown user'}, ${formatMessageTimestamp(cleared.acknowledged_at)}`;
